module.exports = __webpack_public_path__ + "static/media/taiwan-cover.fea8b068.webp";